import Vue from 'vue';
import moment from 'moment';
import 'moment/locale/ru';
import momentDurationFormatSetup from 'moment-duration-format';
import delve from 'dlv';
import classnames from 'classnames';
import uniqid from 'uniqid';
import { abilitiesPlugin, Can } from '@casl/vue';
import { BootstrapVue } from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Vuelidate from 'vuelidate';
import VueWait from 'vue-wait';
import VueChatScroll from 'vue-chat-scroll';

import App from '@/App.vue';
import '@/scss/main.scss';
import Router from '@/router';
import SupportExternalRoute from '@/router/supportExternalRoute';
import Store from '@/store';
import { ability } from '@/casl';
import { InputMaskPlugin } from '@/directives';

// eslint-disable-next-line import/no-named-as-default
import VueGoodTable from './lib/vue-good-table';
import Paginate from './lib/vuejs-paginate';
import { EventBus } from './event-bus';
import { iwalyNotify } from './notify';
import '@/vendor/numeral';
import '@/vendor/voca';
import './registerServiceWorker';

window.moment = require('moment-timezone');

Vue.config.devtools = true;
Vue.config.productionTip = false;

Vue.use(abilitiesPlugin, ability);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueWait);
Vue.use(VueGoodTable);
Vue.use(InputMaskPlugin);
Vue.use(VueChatScroll);
Vue.component('Can', Can);
Vue.component('Paginate', Paginate);

momentDurationFormatSetup(moment);
moment.locale('ru');
Vue.prototype.$moment = moment;
Vue.prototype.$delve = delve;
Vue.prototype.$classnames = classnames;
Vue.prototype.$uniqid = uniqid;
Vue.prototype.$eventBus = EventBus;
Vue.prototype.$iwalyNotify = iwalyNotify;

// Register the V5.2 external SupportChat route before application mount.
// vue-router 3 keeps the wildcard route last when addRoutes() extends the map.
Router.addRoutes([SupportExternalRoute]);

new Vue({
  router: Router,
  store: Store,
  wait: new VueWait({
    useVuex: true,
    vuexModuleName: 'wait',
  }),
  render: (h) => h(App),
}).$mount('#app');
